module.exports = __webpack_public_path__ + "img/gear.144d9cc.svg";